import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import frontLogoVisitorExperience from '../../assets/images/frontLogoVisitorExperience.svg';
import {topBarHeight, topBarHorizontalPadding, topBarVerticalPadding} from '../app/topBar/topBarHelpers';

/*
 * Style.
 */

const StyledTopBarLeftWrapperDiv = styled.div`
  padding: 4px 4px;
`;

const StyledTopBarRightWrapperDiv = styled.div`
  display: flex;
`;

const StyledTopBarWrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  height: ${topBarHeight}px;
  padding: ${topBarVerticalPadding}px ${topBarHorizontalPadding}px;
  background-color: ${(p) => p.theme.greys.black};
`;

/*
 * Methods.
 */

const redirectToSignIn = () => {
  window.location.href = 'https://app.frontapp.com';
};

/*
 * Component.
 */

export const VisitorExperienceTopBar: FC = () => (
  <StyledTopBarWrapperDiv>
    <StyledTopBarLeftWrapperDiv>
      <img alt="visitor-page-company-logo" src={frontLogoVisitorExperience} />
    </StyledTopBarLeftWrapperDiv>
    <StyledTopBarRightWrapperDiv>
      <Button
        isRounded={false}
        variant={ButtonVariantsEnum.LINK}
        color={PaletteColorsEnum.GREY}
        onClick={redirectToSignIn}
      >
        <Trans id="visitor-topbar-signin">Sign in</Trans>
      </Button>
    </StyledTopBarRightWrapperDiv>
  </StyledTopBarWrapperDiv>
);
